import React, { useState } from "react";

import avatar from "../icon/testimonial/avatar.svg";
import dowm_arrow from "../icon/testimonial/down_arrow.svg";
import { useEffect } from "react";

const ImgPath = process.env.REACT_APP_IMg_URL;

const TestimonialImageDisplay = ({ data }) => {
  const [items, setItems] = useState([]);
  const [allData, setAllData] = useState([]);
  const [show, setShow] = useState(false);

  useEffect(() => {
    setAllData(data);
    if (data?.length >= 4) {
      setShow(true);
    }
    setFirstItems(data);
  }, []);

  const setFirstItems = (dataList) => {
    const itemsLen = items.length;
    const alldataLen = dataList.length;
    const newItems = dataList.slice(0, itemsLen + 4);
    setItems(newItems);

    if (newItems.length === alldataLen) {
      setShow(false);
      return;
    }
  };

  const handleNext = () => {
    const itemsLen = items.length;
    const alldataLen = allData.length;
    const newItems = allData.slice(0, itemsLen + 4);
    setItems(newItems);

    if (newItems.length === alldataLen) {
      setShow(false);
      return;
    }
  };

  return (
    <div>
      <div className="flex flex-wrap">
        {items.map((item, ind) => {
          return ind % 2 === 0 ? (
            <Card gradientClass={"gradientDrakOne"} item={item} />
          ) : (
            <Card gradientClass={"gradientDrakTwo"} item={item} />
          );
        })}
      </div>
      {show && (
        <div
          className="flex items-center justify-center cursor-pointer mt-7"
          onClick={handleNext}
        >
          <img src={dowm_arrow} alt="" />
        </div>
      )}
    </div>
  );
};

export default TestimonialImageDisplay;

const Card = ({ gradientClass, item }) => {
  return (
    <div
      className={`flex flex-col justify-center p-6 2xl:p-10 gap-3 min-h-[450px] ${gradientClass} w-full sm:w-[50%]  lg:w-[33.33%] 2xl:w-[25%]`}
    >
      <div>
        <img
          className="rounded-full border-[#F1A130] border-4"
          src={ImgPath + item?.image}
          alt=""
        />
      </div>
      <div className="text-white">
        <h2 className="text-[32px]">{item?.title}</h2>
        <p className="text-base mt-2 image-card-p leading-[21px] w-[90%] text-left">
          {item?.description}
        </p>
        <hr className="bg-[#F1A130] w-[20%] h-[3px] mt-4" />
      </div>
    </div>
  );
};
